import dayjs from "dayjs";
function formatDate(date, showTime = false, options) {
    const defaultFormat = showTime ? "M/D/YYYY (h:mmA)" : "M/D/YYYY";
    if (options) {
        const formattedDate = dayjs(date).format(options.format);
        const [datePart, timePart] = formattedDate.split(" ");
        return { date: datePart, time: timePart || "" };
    }
    return dayjs(date).format(defaultFormat);
}
export default formatDate;
//# sourceMappingURL=formatDate.js.map